export const BASE_PRICE = 299000;

export const SAUNA_IMAGES = [
  'https://harborsaunas.com/cdn/shop/files/G2A6033-min_6fff9c5e-dc4c-4539-8308-9e0a5188999c.jpg?v=1748949346&width=2840',
  'https://harborsaunas.com/cdn/shop/files/G2A6133-min.jpg?v=1748949346&width=2667',
  'https://harborsaunas.com/cdn/shop/files/G2A6040-min.jpg?v=1748949346&width=2667',
  'https://harborsaunas.com/cdn/shop/files/G2A6057-min.jpg?v=1748949346&width=2667',
  'https://harborsaunas.com/cdn/shop/files/G2A6157-3-min.jpg?v=1748949346&width=2667',
  'https://harborsaunas.com/cdn/shop/files/G2A6046-min.jpg?v=1748949346&width=2667',
  'https://harborsaunas.com/cdn/shop/files/G2A6279-min.jpg?v=1748949346&width=2667',
  'https://harborsaunas.com/cdn/shop/files/G2A6222-min.jpg?v=1748949346&width=2667',
  'https://harborsaunas.com/cdn/shop/files/G2A0634-min.jpg?v=1748949346&width=2667',
];

export const CONFIGURATOR_DATA = [
  {
    id: 'cladding',
    label: 'KLEDNING',
    description: 'Velg materiale og utseende for utvendig kledning.',
    options: [
      {
        id: 'painted-light-grey',
        label: 'Malt kledning - Lys grå',
        price: 5000,
        color: '#BFBFBF',
        desc: 'Malt i lett grå tone.',
        img: 'https://media.base44.com/images/public/69ce38ac69be3980b5b33b40/a18b10782_7aefb1cd-5862-4182-b2ac-7947051c7582.jpg',
      },
      {
        id: 'painted-white',
        label: 'Malt kledning - Hvitt',
        price: 5000,
        color: '#FFFFFF',
        desc: 'Malt i klassisk hvitt.',
        img: 'https://media.base44.com/images/public/69ce38ac69be3980b5b33b40/560f32909_d1acbf1a-b159-462a-9521-3ac613968e28.jpg',
      },
      {
        id: 'painted-black',
        label: 'Malt kledning - Sort',
        price: 8000,
        color: '#1A1A1A',
        desc: 'Malt i dypsvart tone.',
        img: 'https://media.base44.com/images/public/69ce38ac69be3980b5b33b40/a54c6fb6f_9b23177d-922b-4c17-b419-60af81952e30.jpg',
      },
      {
        id: 'painted-dark-blue',
        label: 'Malt kledning - Mørk blå',
        price: 8000,
        color: '#2E4A6B',
        desc: 'Malt i mørk blåtone.',
        img: 'https://media.base44.com/images/public/69ce38ac69be3980b5b33b40/517fd595d_a900511f-411e-412d-881f-029a90db3a46.jpg',
      },
      {
        id: 'painted-dark-brown',
        label: 'Malt kledning - Mørk brunn',
        price: 8000,
        color: '#4A3A2A',
        desc: 'Malt i mørk brunntone.',
        img: 'https://media.base44.com/images/public/69ce38ac69be3980b5b33b40/dfa4405bc_29576665-8ffe-4a3e-989c-3bca2da1f741.jpg',
      },
      {
        id: 'thermofir-oil',
        label: 'Termofuru olje behandlet',
        price: 12000,
        color: '#8B7355',
        desc: 'Termisk modifisert furu med oljebehandling.',
        img: 'https://media.base44.com/images/public/69ce38ac69be3980b5b33b40/a18b10782_7aefb1cd-5862-4182-b2ac-7947051c7582.jpg',
      },
      {
        id: 'kebony-radiata',
        label: 'Kebony Clear Radiata',
        price: 15000,
        color: '#A0826D',
        desc: 'Edel kivibehandlet radiata furu.',
        img: 'https://media.base44.com/images/public/69ce38ac69be3980b5b33b40/560f32909_d1acbf1a-b159-462a-9521-3ac613968e28.jpg',
      },
      {
        id: 'grey-weathered-pine',
        label: 'Gråforvitret Furu',
        price: 0,
        default: true,
        color: '#B8A99A',
        desc: 'Naturlig gråpatina — klassisk nordisk uttrykk.',
        img: 'https://media.base44.com/images/public/69ce38ac69be3980b5b33b40/a18b10782_7aefb1cd-5862-4182-b2ac-7947051c7582.jpg',
      },
    ],
  },

  {
    id: 'ovenModel',
    label: 'BADSTUEOVN',
    description: 'Velg ovnmodell og størrelse.',
    options: [
      {
        id: 'compact-8kw',
        label: 'Compact 8kW',
        price: 0,
        default: true,
        color: '#8B6F47',
        desc: 'For små badstuer.',
      },
      {
        id: 'standard-12kw',
        label: 'Standard 12kW',
        price: 8000,
        color: '#9B7D4D',
        desc: 'Mest populær.',
      },
      {
        id: 'premium-18kw',
        label: 'Premium 18kW',
        price: 15000,
        color: '#A8886D',
        desc: 'For store rom.',
      },
      {
        id: 'iki-loyly-jr',
        label: 'IKI Loyly JR',
        price: 22000,
        color: '#8B4513',
        desc: 'Premium vedovn med design.',
        img: 'https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/7ab40f989_IKI_LoylyJR.png',
      },
      {
        id: 'harvia-cilindro-pc90',
        label: 'Harvia Cilindro PC90 sort - elektrisk',
        price: 0,
        color: '#1A1A1A',
        desc: 'Elektrisk ovn, sort design.',
      },
    ],
  },
  {
    id: 'interiorPanels',
    label: 'INNVENDIGE PANEL',
    description: 'Velg material for innvendige vegger.',
    options: [
      {
        id: 'aspen',
        label: 'Asp',
        price: 0,
        default: true,
        color: '#E8D4C0',
        desc: 'Lyst tre, klassisk.',
      },
      {
        id: 'alder',
        label: 'Eller',
        price: 5000,
        color: '#D4A574',
        desc: 'Varmere tone.',
      },
      {
        id: 'oak',
        label: 'Eik',
        price: 12000,
        color: '#8B6F47',
        desc: 'Robust og vakker.',
      },
    ],
  },
  {
    id: 'floor',
    label: 'GULV',
    description: 'Velg gulvmateriale.',
    options: [
      {
        id: 'treated-wood',
        label: 'Behandlet Tre',
        price: 0,
        default: true,
        color: '#B8956A',
        desc: 'Standard behandlet furu.',
      },
      {
        id: 'stone-tiles',
        label: 'Steinflis',
        price: 8000,
        color: '#7A7A7A',
        desc: 'Holdbar og enkel rengjøring.',
      },
      {
        id: 'heated-floor',
        label: 'Oppvarmet gulv med flis',
        price: 15000,
        color: '#A8956A',
        desc: 'Integrert oppvarming.',
      },
    ],
  },
  {
    id: 'lighting',
    label: 'BELYSNING OG LYD ANLEGG',
    description: 'Velg belysning og lydløsning.',
    options: [
      {
        id: 'basic-lights',
        label: 'Grunnleggende Belysning',
        price: 0,
        default: true,
        color: '#E8C79E',
        desc: 'LED-lys.',
      },
    ],
  },
  {
    id: 'doors',
    label: 'DØRER',
    description: 'Velg dørtype og materiale.',
    options: [
      {
        id: 'glass-door',
        label: 'Glassedør',
        price: 0,
        default: true,
        color: '#C0D0E8',
        desc: 'Klar herdet glass.',
      },
      {
        id: 'glass-door-bronze',
        label: 'Glassedør (Bronse)',
        price: 5000,
        color: '#8B6F47',
        desc: 'Farget glass.',
      },
      {
        id: 'wooden-door',
        label: 'Tredør',
        price: 8000,
        color: '#A8886D',
        desc: 'Klassisk tredør.',
      },
    ],
  },
  {
    id: 'windows',
    label: 'VINDU',
    description: 'Velg vindutype.',
    options: [
      {
        id: 'no-window',
        label: 'Ingen Vindu',
        price: 0,
        default: true,
        color: '#8B7355',
        desc: 'Ingen vindu.',
      },
      {
        id: 'small-window',
        label: 'Lite Vindu',
        price: 8000,
        color: '#A8A8C0',
        desc: 'Liten glassåpning.',
      },
      {
        id: 'large-window',
        label: 'Stort Vindu',
        price: 15000,
        color: '#B0D0E8',
        desc: 'Stort glassvindu.',
      },
    ],
  },
  {
    id: 'extras',
    label: 'EKSTRA',
    description: 'Velg tilleggsutstyr.',
    options: [
      {
        id: 'no-extras',
        label: 'Ingen Ekstra',
        price: 0,
        default: true,
        color: '#D4C5B9',
        desc: 'Basiskonfigurasjon.',
      },
      {
        id: 'towel-rack',
        label: 'Harvia Komplett Pakke Hvitt',
        price: 3000,
        color: '#FFFFFF',
        desc: 'Oppvarmet håndklestativ.',
      },
      {
        id: 'backrest',
        label: 'Harvia Komplett Pakke Sort/brunn',
        price: 5000,
        color: '#4A3A2A',
        desc: 'Komfortabel ryggstøtte.',
      },
      {
        id: 'full-package',
        label: 'Harvia Komplett Pakke Terrakotta',
        price: 12000,
        color: '#C85A54',
        desc: 'Håndklestativ + ryggstøtte.',
      },
    ],
  },
];